<div class="multiselect-container" *ngIf="filter">
    <label class="field-label typography-component-input-label ng-star-inserted">
        {{ filter.fieldName }}
    </label>
    <button
        class="multiselect-toggle"
        (click)="!isDisabled && toggleDropdown()"
        [class.multiselect-toggle--disabled]="isDisabled"
    >
        <span [class.multiselect-toggle__placeholder]="!selectedValues?.length">
            {{ placeholder }}
        </span>
        <img src="/assets/icons/arrow-down.svg" alt="" />
    </button>
    <div class="multiselect-dropdown" [hidden]="!showDropdown">
        <div class="multiselect-dropdown__loader" *ngIf="showLoader">
            <img src="/assets/icons/blue-loading.svg" alt="Loading" class="animation-spin" />
            <p>{{ loaderMessage }}</p>
        </div>
        <ng-container *ngIf="filter.options?.length && !showLoader; else emptyData">
            <div
                id="{{ 'filterOption' + option }}"
                class="multiselect-option"
                [class.selected]="isSelected(option)"
                *ngFor="let option of filter.options"
            >
                <label [title]="option">
                    <input
                        type="checkbox"
                        [value]="option"
                        [disabled]="isOptionDisabled"
                        [checked]="isSelected(option)"
                        (change)="toggleSelection(option)"
                    />
                    {{ option }}
                </label>
            </div>
        </ng-container>
        <ng-template #emptyData>
            <ng-content select="[emptyData]"></ng-content>
        </ng-template>
    </div>
</div>
